<template>
  <div>
    <v-aside />
    <v-main>
      <v-container fluid>
        <router-view v-if="routeIsAllowed" :key="$route.path" />
        <access-denied v-else />
      </v-container>
    </v-main>
    <v-stepper />
    <blocked-overlay layout="order" />
  </div>
</template>

<script>
  // import VAside from '@/components/order-processing/edit-order/aside/Aside'
  import VAside from '@/components/order-processing/order-components/aside/Aside.vue'
  import VStepper from '@/components/order-processing/edit-order/stepper/Stepper'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import AccessDenied from '@/components/app/AccessDenied.vue'
  import BlockedOverlay from '@/components/billing/BlockedOverlay.vue'
  import { isEmpty } from 'lodash'

  export default {
    name: 'EditOrderLayout',
    components: {
      AccessDenied,
      BlockedOverlay,
      VAside,
      VStepper,
    },
    mixins: [mixinSnackbarMessage],
    computed: {
      routeIsAllowed () {
        if (isEmpty(this.$route?.meta?.permissions)) {
          return true
        }
        return this.userCan(this.$route.meta.permissions)
      },
    },
    created () {
      this.$store.commit('app/hideFloatingButtons')
    },
    mounted () {
      this.getFilials()
    },
    methods: {
      getFilials () {
        const payload = {
          limit: 100000,
          offset: 0,
          page: 1,
          type: 'personal',
        }
        this.$store.dispatch('branches/fetchBranches', { payload })
          .then(res => {
            if (res.status !== 200) {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
    },
  }
</script>
